<template>
    <div class="container admin-table-page">

        <!-- ==================== TÍTULO ==================== -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button
                        class="page-back-btn mr-2"
                        variant="link"
                        @click="goBack"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'arrow-alt-circle-left']"
                            class="back-icon"
                        />
                    </b-button>

                    <h2 class="param-title">
                        {{ tituloConsolidado || labels.title }}
                    </h2>
                </div>
            </div>
        </div>

        <!-- ==================== FILTROS ==================== -->
        <div class="param-title-wrap niif-header">
            <div
                class="d-flex align-items-center w-100"
                style="flex-wrap: wrap; gap: 8px;"
            >

                <!-- Filtros principales -->
                <div
                    class="filters-container d-flex align-items-center"
                    style="flex-wrap: wrap; gap: 8px;"
                >

                    <!-- Reporte -->
                    <b-form-select
                        v-model="selReporte"
                        @change="onFiltroChange"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectReport }}
                        </b-form-select-option>

                        <option
                            v-for="reporte in listReporte"
                            :key="reporte.id"
                            :value="reporte.codigo"
                        >
                            {{ reporte?.nombre }}
                        </option>
                    </b-form-select>

                    <!-- Vigencia -->
                    <b-form-select
                        v-model="selVigencia"
                        @change="onFiltroChange"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectValidity }}
                        </b-form-select-option>

                        <option
                            v-for="vigencia in listVigencia"
                            :key="vigencia.vigencia"
                            :value="vigencia.vigencia"
                        >
                            {{ vigencia?.vigencia }}
                        </option>
                    </b-form-select>

                    <!-- Grupo -->
                    <b-form-select
                        v-model="grupoId"
                        @change="(value) => filtraCompaniasPorGrupo(value)"
                        class="filter-select"
                    >
                        <option value="todos">
                            {{ labels.allGroups }}
                        </option>

                        <option
                            v-for="grupo in listGrupos"
                            :key="'grupo-' + grupo.id"
                            :value="grupo.id"
                        >
                            {{ grupo?.nombre }}
                        </option>
                    </b-form-select>

                    <!-- Compañía -->
                    <b-form-select
                        v-model="companyId"
                        @change="seleccionaCompania()"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectCompany }}
                        </b-form-select-option>

                        <option
                            v-for="compania in filteredCompany"
                            :key="compania.id"
                            :value="compania.id"
                        >
                            {{ compania?.acronym ? compania?.acronym + ' ' : '' }}
                            {{ compania?.nombre }}
                        </option>
                    </b-form-select>

                    <!-- Dropdown de selección única para vistas -->
                    <b-dropdown
                        variant="outline-secondary"
                        class="filter-dropdown"
                        toggle-class="filter-dropdown-btn"
                        :text="selectedViewOptionText"
                    >
                        <!-- Grupo Reportes -->
                        <b-dropdown-header>Reportes</b-dropdown-header>
                        <b-dropdown-item
                            v-for="option in viewOptions.filter(o => o.group === 'Reportes')"
                            :key="option.value"
                            @click="selectViewOption(option.value)"
                            :active="selectedViewOption === option.value"
                        >
                            {{ option.text }}
                        </b-dropdown-item>

                        <b-dropdown-divider></b-dropdown-divider>

                        <!-- Grupo Información -->
                        <template v-if="viewOptions.some(o => o.group === 'Información')">
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-header>Información</b-dropdown-header>
                            <b-dropdown-item
                                v-for="option in viewOptions.filter(o => o.group === 'Información')"
                                :key="option.value"
                                @click="selectViewOption(option.value)"
                                :active="selectedViewOption === option.value"
                            >
                                {{ option.text }}
                            </b-dropdown-item>
                        </template>
                    </b-dropdown>

                </div>

                <!-- Botones -->
                <div class="filters-container d-flex align-items-center">

                    <!-- Generar -->
                    <b-button
                        class="consult-btn"
                        @click="consultarDatos"
                        :disabled="!puedeGenerar"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'search']"
                            class="mr-1"
                        />

                        {{ labels.generar }}
                    </b-button>

                </div>

            </div>
        </div>

        <!-- ==================== MODAL SELECCIÓN DE EMPRESAS PARA CONSOLIDADO ==================== -->
        <b-modal
            v-model="showEmpresasModal"
            :title="labels.selectCompanies"
            size="lg"
            @hidden="showEmpresasModal = false"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-ajuste-dialog"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title" style="font-size: 16px; font-weight: 600; color: #2e507a;">
                        {{ labels.selectCompaniesTitle }}
                    </div>
                    <div class="password-policy-subtitle" style="font-size: 14px; color: #6c757d;">
                        {{ labels.selectCompaniesSubtitle }}
                    </div>
                </div>

                <!-- Lista de empresas -->
                <div class="accounts-section mt-2">
                    <div v-if="filteredCompany.length > 0" class="accounts-list mt-1">
                        <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                            <b-button
                                size="sm"
                                style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                @click="toggleSelectAllCompaniesModal"
                            >
                                {{ selectAllCompaniesModal ? labels.deselectAll : labels.selectAll }}
                            </b-button>
                            <span style="font-size: 13px; color: #6c757d;">
                                {{ labels.selected }}: <strong>{{ empresasSeleccionadas.length }}</strong> / {{ filteredCompany.length }}
                            </span>
                        </div>

                        <div class="custom-scroll-table" style="min-height: 200px; height: auto; max-height: 300px; overflow-y: auto;">
                            <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                    <tr>
                                        <th style="width: 100px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                            {{ labels.code }}
                                        </th>
                                        <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                            {{ labels.companyName }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="compania in filteredCompany"
                                        :key="compania.id"
                                        @click="toggleCompanySelectionModal(compania)"
                                        :class="{'table-active-blue': isCompanySelectedModal(compania)}"
                                        style="cursor: pointer; border-radius: 8px;"
                                    >
                                        <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                            <strong>{{ compania?.acronym || compania?.codigo || '' }}</strong>
                                        </td>
                                        <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="compania.nombre">
                                            {{ compania?.nombre }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-else class="text-center py-4" style="height: 200px; display: flex; align-items: center; justify-content: center;">
                        <span class="text-muted" style="font-size: 13px;">{{ labels.noCompaniesAvailable }}</span>
                    </div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button
                        class="mr-2 reset-btn-secondary"
                        @click="closeEmpresasModal"
                        :disabled="isSavingCompanies"
                        style="font-size: 14px; padding: 6px 24px;"
                    >
                        {{ labels.close }}
                    </b-button>
                    <b-button
                        class="reset-btn-primary"
                        @click="confirmEmpresasSelectionModal"
                        :disabled="isSavingCompanies || empresasSeleccionadas.length === 0"
                        style="font-size: 14px; padding: 6px 24px;"
                    >
                        {{ labels.confirmSelection }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- ========================================================= -->
        <!-- ==================== CONTENIDO PRINCIPAL ================= -->
        <!-- ========================================================= -->
        <div class="admin-table-block mt-4">

            <!-- ==================== BALANCE ==================== -->
            <div v-if="mostrarBalance">
                <CorporateDataTable
                    :items="listReportesGuardados"
                    :fields="balanceFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="listReportesGuardados.length || 10"
                    :page-options="[listReportesGuardados.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="balanceFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel && listReportesGuardados?.length > 0"
                                @click="exportarExcel"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== REPORTE ==================== -->
            <div v-if="mostrarReporte">
                <CorporateDataTable
                    :items="listReportesComparativo"
                    :fields="reporteFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="listReportesComparativo.length || 10"
                    :page-options="[listReportesComparativo.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="reporteFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel && listReportesComparativo?.length > 0"
                                @click="exportarExcelReporte"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== INFORMACIÓN (VALOR MANUAL) ==================== -->
            <div v-if="mostrarInformacion">
                <CorporateDataTable
                    :items="listFilasManuales"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="listFilasManuales.length || 10"
                    :page-options="[listFilasManuales.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="exportarExcelManual"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="abrirModalValor(data.item)"
                            :disabled="isVigenciaBloqueada"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== AJUSTE CONSOL ==================== -->
            <div v-if="mostrarAjusteConsol">
                <CorporateDataTable
                    :items="listFilasManuales"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="listFilasManuales.length || 10"
                    :page-options="[listFilasManuales.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="exportarExcelManual"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px; padding: 0; border-radius: 50%; border: none;"
                            class="md-fab md-primary table-action-btn"
                            @click="abrirModalValor(data.item)"
                            :disabled="isVigenciaBloqueada"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== AJUSTE COMBINADO ==================== -->
            <div v-if="mostrarAjusteCombinado">
                <CorporateDataTable
                    :items="listFilasManuales"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="listFilasManuales.length || 10"
                    :page-options="[listFilasManuales.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="exportarExcelManual"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px; padding: 0; border-radius: 50%; border: none;"
                            class="md-fab md-primary table-action-btn"
                            @click="abrirModalValor(data.item)"
                            :disabled="isVigenciaBloqueada"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== CONSOLIDADO ==================== -->
            <div v-if="mostrarConsolidado">
                <CorporateDataTable
                    :items="listConsolidado"
                    :fields="consolidadoFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="listConsolidado.length || 10"
                    :page-options="[listConsolidado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="consolidadoFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right d-flex align-items-center" style="gap: 8px; flex-wrap: wrap;">

                            <!-- Selector de moneda -->
                            <b-form-select
                                v-if="mostrarSelectorMonedaConsolidado"
                                v-model="monedaConsolidadoSeleccion"
                                @change="onCambioMonedaConsolidado"
                                class="form-control form-control-sm"
                                style="min-width: 165px; max-width: 165px;"
                            >
                                <option
                                    v-for="option in monedaConsolidadoOptions"
                                    :key="'reporte-' + option.value"
                                    :value="option.value"
                                >
                                    {{ option?.text }}
                                </option>
                            </b-form-select>

                            <!-- Switch Normal / Combinado -->
                            <div class="compact-toggle-container d-flex align-items-center" style="gap: 8px;">
                                <span style="font-size: 13px; color: #495057; font-weight: 500;">{{ vistaConsolidado === 'Normal' ? labels.normal : labels.combined }}</span>
                                <label class="compact-switch" style="margin: 0;">
                                    <input type="checkbox" v-model="vistaConsolidadoBool">
                                    <span class="compact-slider"></span>
                                </label>
                            </div>

                            <!-- Exportar Excel -->
                            <b-button
                                v-if="fgl_excel && listConsolidado?.length > 0"
                                @click="exportarExcelConsolidado"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>

                        </div>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ========================================================= -->
            <!-- ==================== SIN SELECCIÓN ====================== -->
            <!-- ========================================================= -->
            <div
                v-if="
                    !mostrarBalance &&
                    !mostrarReporte &&
                    !mostrarInformacion &&
                    !mostrarAjusteConsol &&
                    !mostrarAjusteCombinado &&
                    !mostrarConsolidado
                "
            >
                <CorporateDataTable
                    :items="[]"
                    :fields="[]"
                    :labels="tableLabels"
                    :loading="false"
                    :default-per-page="10"
                    :page-options="[10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="false"
                    :allow-column-toggle="false"
                    :enable-sorting="false"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #empty-state>
                        <div class="text-center py-5">
                            <img
                                src="../../assets/imgs/file-2.svg"
                                alt="warning"
                                class="mb-3"
                                style="opacity: 0.3; width: 80px;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.selectCriteria }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

        </div>

        <!-- ==================== MODAL INFORMACIÓN (VALOR MANUAL) ==================== -->
        <b-modal
            v-model="showModalValor"
            :title="modalTitle"
            @hidden="cerrarModalValor"
            header-class="modal-header-custom"
            footer-class="modal-footer-custom"
            size="md"
        >
            <b-form @submit.prevent="guardarValorManual">
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.descripcion }}</label>
                        <b-form-input
                            :value="filaSeleccionada ? filaSeleccionada.descripcion : ''"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.monto }}</label>
                        <b-form-input
                            v-model="valorIngresado"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                            placeholder="Ingrese el valor"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.funcional1 }}</label>
                        <b-form-input
                            v-model="funcional1Ingresado"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                            placeholder="Ingrese el valor funcional"
                        />
                    </b-col>
                </b-row>
            </b-form>

            <template #footer>
                <b-button
                    variant="primary"
                    @click="guardarValorManual"
                    :disabled="isVigenciaBloqueada || valorIngresado === null || valorIngresado === '' || funcional1Ingresado === null || funcional1Ingresado === ''"
                >
                    {{ labels.save }}
                </b-button>
                <b-button
                    variant="secondary"
                    @click="cerrarModalValor"
                >
                    {{ labels.close }}
                </b-button>
            </template>
        </b-modal>

        <!-- ==================== MODAL DE PROGRESO EXCEL ==================== -->
        <b-modal
            v-model="showGeneratingModal"
            title="Generando Excel"
            hide-footer
            centered
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="text-center">
                <div class="modern-spinner">
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                </div>

                <p class="mt-3 mb-1 loading-message">
                    {{ generatingMessage }}
                </p>
                <p class="loading-submessage">{{ generatingSubMessage }}</p>

                <div class="loading-progress-container">
                    <div
                        class="loading-progress-bar"
                        :style="{ width: generatingProgress + '%' }"
                    ></div>
                </div>

                <span class="loading-percentage">{{ generatingProgress }}%</span>
            </div>
        </b-modal>

    </div>
</template>

<script>
import Company from "../../services/Company"
import PlanCuentas from "../../services/PlanCuentas"
import TipoReporte from '../../services/TipoReporte';
import Grupo from "../../services/Grupo";
import Balance from "../../services/BalanceNiif";
import Currency from "../../services/Currency";
import BotonesControl from "../../services/BotonesControl";
import CorporateDataTable from '../utils/CorporateDataTable.vue'
import * as XLSX from "exceljs";

export default {
    name: "ReporteORI",
    components: {
        CorporateDataTable
    },
    data: () => ({
        selectedViewOption: null,

        // Modal de empresas
        showEmpresasModal: false,
        selectAllCompaniesModal: false,
        isSavingCompanies: false,
        fromButtonGenerate: false,

        // Variables de estado
        showModalValor: false,
        filaSeleccionada: null,
        valorIngresado: null,
        funcional1Ingresado: null,

        // Filtros
        selReporte: "",
        selVigencia: "",
        grupoId: "todos",
        companyId: "",

        progressInterval: null,
        progressStartTime: null,
        progressEstimatedTime: 40,
        progressCurrentMessageIndex: 0,
        progressMessageInterval: null,
        progressMessages: [
            'Cargando información...',
            'Preparando datos...',
            'Procesando solicitud...',
            'Esto puede tomar unos segundos...',
            'Casi listo...'
        ],

        // Modal de progreso (solo para Excel)
        showGeneratingModal: false,
        generatingMessage: '',
        generatingSubMessage: '',
        generatingProgress: 0,

        // Listas
        listReporte: [],
        listVigencia: [],
        listGrupos: [],
        listCompany: [],
        filteredCompany: [],
        listReportesGuardados: [],
        listReportesComparativo: [],
        listFilasManuales: [],
        listConsolidado: [],

        // Estado
        isLoading: false,
        datosConsultados: false,
        fgl_excel: true,
        error: false,

        // Tipos de vista
        mostrarBalance: false,
        mostrarReporte: false,
        mostrarInformacion: false,
        mostrarAjusteConsol: false,
        mostrarAjusteCombinado: false,
        mostrarConsolidado: false,

        // Consolidado
        empresasSeleccionadas: [],
        selectAllCompanies: false,
        columnasConsolidado: [],
        empresasConsolidadoNombres: {},
        empresasConsolidadoNombresDiff: {}, // NUEVO: para nombres de columnas de diferencia de cambio
        vistaConsolidado: "Normal",
        monedaConsolidadoSeleccion: 'funcional1',
        currency: [],

        // Vigencia
        vigenciaActual: '',
        vigenciaAnterior: '',

        // Título
        tituloConsolidado: "",
    }),
    computed: {
        vistaConsolidadoBool: {
            get() {
                return this.vistaConsolidado === 'Combinado';
            },
            set(value) {
                this.vistaConsolidado = value ? 'Combinado' : 'Normal';
                if (this.datosConsultados && this.mostrarConsolidado) {
                    this.consultarDatos();
                }
            }
        },

        viewOptions() {
            const es = this.$store.state._language == "es-ES"
            const options = []

            if (this.$store.getters.isControlVisible('ReporteORI', 'Reporte')) {
                options.push({ value: 'reporte', text: es ? 'Individual' : 'Individual', group: 'Reportes' })
            }
            if (this.isConsolidadoVisible) {
                options.push({ value: 'consolidado', text: es ? 'Consolidado' : 'Consolidated', group: 'Reportes' })
            }
            if (this.$store.getters.isControlVisible('ReporteORI', 'Informacion')) {
                options.push({ value: 'informacion', text: es ? 'Valor Manual' : 'Manual Value', group: 'Información' })
            }
            if (this.$store.getters.isControlVisible('ReporteORI', 'AjusteConsol')) {
                options.push({ value: 'ajusteConsol', text: es ? 'Ajuste Consol' : 'Consol Adjustment', group: 'Información' })
            }
            if (this.$store.getters.isControlVisible('ReporteORI', 'AjusteCombinado')) {
                options.push({ value: 'ajusteCombinado', text: es ? 'Ajuste Combinado' : 'Combined Adjustment', group: 'Información' })
            }

            return options
        },

        puedeGenerar() {
            if (!this.selVigencia) return false
            if (!this.selReporte) return false
            if (!this.selectedViewOption) return false
            if (this.isLoading) return false

            // Consolidado: nunca exige compañía
            if (this.selectedViewOption === 'consolidado') {
                return true
            }

            // Resto de vistas exigen compañía
            return !!this.companyId
        },
        selectedViewOptionText() {
            if (!this.selectedViewOption) return this.$store.state._language == "es-ES" ? "Seleccione Vista" : "Select View"
            const option = this.viewOptions.find(opt => opt.value === this.selectedViewOption)
            return option ? option.text : this.$store.state._language == "es-ES" ? "Seleccione Vista" : "Select View"
        },
        isVigenciaBloqueada() {
            return this.selVigencia ? !this.$store.getters.isPeriodoEnabled(this.selVigencia) : false
        },
        isConsolidadoVisible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'Consolidado')
        },
        isSelectorMonedaVisible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'SelectorMoneda')
        },
        isMonedaFuncional1Visible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'MonedaFuncional1')
        },
        isMonedaFuncional2Visible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'MonedaFuncional2')
        },
        monedaConsolidadoOptions() {
            const options = []
            const moneda1 = this.getNombreMonedaConsolidado('funcional1')
            const moneda2 = this.getNombreMonedaConsolidado('funcional2')
            if (this.isMonedaFuncional1Visible && moneda1) {
                options.push({ value: 'funcional1', text: moneda1 })
            }
            if (this.isMonedaFuncional2Visible && moneda2) {
                options.push({ value: 'funcional2', text: moneda2 })
            }
            return options
        },
        mostrarSelectorMonedaConsolidado() {
            return this.mostrarConsolidado &&
                this.isSelectorMonedaVisible &&
                this.monedaConsolidadoOptions.length > 1
        },
        modalTitle() {
            if (this.mostrarAjusteCombinado) {
                return this.$store.state._language == "es-ES" ? "Ajuste Combinado" : "Combined Adjustment"
            } else if (this.mostrarAjusteConsol) {
                return this.$store.state._language == "es-ES" ? "Ajuste Consolidado" : "Consolidated Adjustment"
            } else {
                return this.$store.state._language == "es-ES" ? "Valor Manual" : "Manual Value"
            }
        },
        labels() {
            const es = this.$store.state._language == "es-ES"
            return {
                title: es ? "Estado de Otros Resultados Integrales" : "STATEMENT OF OTHER COMPREHENSIVE INCOME",
                selectReport: es ? "Seleccione Reporte" : "Select Report",
                selectValidity: es ? "Seleccione Vigencia" : "Select Validity",
                selectCompany: es ? "Seleccione Compañía" : "Select Company",
                allGroups: es ? "Todos los grupos" : "All groups",
                balance: es ? "Balance" : "Balance",
                reporte: es ? "Reporte" : "Report",
                consolidado: es ? "Consolidado" : "Consolidated",
                informacion: es ? "Valor Manual" : "Manual Value",
                ajusteConsol: es ? "Ajuste Consol" : "Consol Adjustment",
                ajusteCombinado: es ? "Ajuste Combinado" : "Combined Adjustment",
                normal: es ? "Normal" : "Normal",
                combined: es ? "Combinado" : "Combined",
                selectCompanies: es ? "Empresas para consolidar" : "Companies to consolidate",
                selectCompaniesTitle: es ? "Selección de empresas" : "Company Selection",
                selectCompaniesSubtitle: es ? "Seleccione las empresas que desea consolidar" : "Select the companies you want to consolidate",
                code: es ? "Código" : "Code",
                companyName: es ? "Nombre" : "Name",
                confirmSelection: es ? "Confirmar selección" : "Confirm selection",
                noCompaniesAvailable: es ? "No hay empresas disponibles" : "No companies available",
                selectAll: es ? "Seleccionar todas" : "Select all",
                deselectAll: es ? "Deseleccionar todas" : "Deselect all",
                selected: es ? "Seleccionadas" : "Selected",
                descripcion: es ? "Descripción" : "Description",
                local: es ? "Local" : "Local",
                funcional1: es ? "Funcional" : "Functional",
                interna: es ? "Interna" : "Internal",
                saldo_actual: es ? "Saldo Actual" : "Current Balance",
                monto: es ? "Valor" : "Amount",
                ajustes: es ? "Ajustes" : "Adjustments",
                total: es ? "Total" : "Total",
                empty: es ? "Sin Información" : "Without Information",
                generar: es ? "Generar" : "Generate",
                moneda: es ? "Moneda" : "Currency",
                exportExcel: es ? "Exportar Excel" : "Export Excel",
                selectCriteria: es ? "Seleccione un reporte, vigencia y compañía para generar la información" : "Select a report, validity and company to generate the information",
                save: es ? "Guardar" : "Save",
                close: es ? "Cerrar" : "Close",
                noSort: es ? "Sin orden" : "No sorting",
                sortAsc: es ? "A-Z / Menor a mayor" : "A-Z / Low to high",
                sortDesc: es ? "Z-A / Mayor a menor" : "Z-A / High to low",
                columns: es ? "Columnas" : "Columns",
                showAllColumns: es ? "Mostrar todas" : "Show all",
                filters: es ? "Filtros" : "Filters",
                clearFilters: es ? "Limpiar filtros" : "Clear filters",
                rowsPerPage: es ? "Filas por página:" : "Rows per page:",
                searchPlaceholder: es ? "Buscar en la tabla..." : "Search in table...",
                noData: es ? "No hay datos disponibles" : "No data available",
                noMatches: es ? "No se encontraron resultados" : "No results found",
                edit: es ? "Editar" : "Edit",
            }
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        balanceFields() {
            return [
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' },
                { key: 'saldo_local', label: this.labels.local, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formatCurrency(value) },
                { key: 'saldo_funcional', label: this.labels.funcional1, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formatCurrency(value) },
                { key: 'saldo_interna', label: this.labels.interna, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formatCurrency(value) }
            ]
        },
        balanceFilterDefs() {
            return [
                { key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
            ]
        },
        reporteFields() {
            return [
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' },
                { key: 'saldo_actual', label: this.vigenciaActual || this.labels.saldo_actual, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formatCurrency(value) }
            ]
        },
        reporteFilterDefs() {
            return [
                { key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
            ]
        },
        informacionFields() {
            return [
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' },
                { key: 'valorGuardado', label: this.labels.monto, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formatCurrency(value) },
                { key: 'funcional1Guardado', label: this.labels.funcional1, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formatCurrency(value) },
                { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center', sortable: false, minWidth: '60px' }
            ]
        },
        informacionFilterDefs() {
            return [
                { key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
            ]
        },
        consolidadoFields() {
            const fields = [
                { 
                    key: 'descripcion', 
                    label: this.labels.descripcion, 
                    sortable: true, 
                    thClass: 'text-left', 
                    tdClass: 'text-left align-middle', 
                    minWidth: '250px' 
                }
            ]

            // Columnas dinámicas: Saldo + Diferencia Cambio por cada empresa
            for (let i = 0; i < this.columnasConsolidado.length; i++) {
                const col = this.columnasConsolidado[i]
                const index = this.getIndiceColumnaConsolidado(col)
                
                // Columna de Saldo - usamos el nombre del campo real
                const labelSaldo = this.empresasConsolidadoNombres[col] || `Empresa ${i + 1} Saldo`
                fields.push({
                    key: `sal${index}`,
                    label: labelSaldo,
                    sortable: true,
                    thClass: 'text-right',
                    tdClass: 'text-right align-middle',
                    minWidth: '120px',
                    formatter: (value) => this.formatCurrency(value)
                })
                
                // Columna de Diferencia Cambio
                const labelDiff = this.empresasConsolidadoNombresDiff[col] || `Empresa ${i + 1} Diff`
                fields.push({
                    key: `diff_${col}`,
                    label: labelDiff,
                    sortable: true,
                    thClass: 'text-right',
                    tdClass: 'text-right align-middle',
                    minWidth: '120px',
                    formatter: (value, key, item) => this.formatCurrency(this.getDiffCambioConsolidado(item, col))
                })
            }

            fields.push(
                { 
                    key: 'ajustes', 
                    label: this.labels.ajustes, 
                    sortable: true, 
                    thClass: 'text-right', 
                    tdClass: 'text-right align-middle', 
                    minWidth: '120px', 
                    formatter: (value) => this.formatCurrency(value) 
                },
                { 
                    key: 'total_consolidado', 
                    label: this.labels.consolidado, 
                    sortable: true, 
                    thClass: 'text-right', 
                    tdClass: 'text-right align-middle', 
                    minWidth: '120px', 
                    formatter: (value) => this.formatCurrency(value) 
                },
                { 
                    key: 'total_diff_cambio', 
                    label: 'Consolidado Diferencia Cambio', 
                    sortable: true, 
                    thClass: 'text-right', 
                    tdClass: 'text-right align-middle', 
                    minWidth: '150px', 
                    formatter: (value, key, item) => this.formatCurrency(this.getTotalDiffCambioConsolidado(item)) 
                }
            )

            if (this.vistaConsolidado === 'Combinado') {
                fields.push(
                    { 
                        key: 'combinado', 
                        label: this.labels.ajusteCombinado, 
                        sortable: true, 
                        thClass: 'text-right', 
                        tdClass: 'text-right align-middle', 
                        minWidth: '120px', 
                        formatter: (value) => this.formatCurrency(value) 
                    },
                    { 
                        key: 'total_combinado', 
                        label: this.labels.total, 
                        sortable: true, 
                        thClass: 'text-right', 
                        tdClass: 'text-right align-middle', 
                        minWidth: '120px', 
                        formatter: (value) => this.formatCurrency(value) 
                    }
                )
            }

            return fields
        },
        consolidadoFilterDefs() {
            return [
                { key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
            ]
        }
    },
    watch: {
        selectedViewOption(newVal) {
            this.mostrarBalance = false
            this.mostrarReporte = false
            this.mostrarInformacion = false
            this.mostrarAjusteConsol = false
            this.mostrarAjusteCombinado = false
            this.mostrarConsolidado = false

            switch(newVal) {
                case 'reporte':
                    this.mostrarReporte = true
                    break
                case 'consolidado':
                    this.mostrarConsolidado = true
                    break
                case 'informacion':
                    this.mostrarInformacion = true
                    break
                case 'ajusteConsol':
                    this.mostrarAjusteConsol = true
                    break
                case 'ajusteCombinado':
                    this.mostrarAjusteCombinado = true
                    break
            }

            this.onFiltroChange()
            this.f_titulo()
        }
    },
    methods: {
        // ==================== MÉTODOS DE SELECCIÓN DE VISTA ====================
        selectViewOption(value) {
            this.selectedViewOption = value
        },

        // ==================== MÉTODOS PARA EL MODAL DE EMPRESAS ====================
        isCompanySelectedModal(compania) {
            return this.empresasSeleccionadas.includes(compania.id)
        },

        toggleCompanySelectionModal(compania) {
            const index = this.empresasSeleccionadas.indexOf(compania.id)
            if (index > -1) {
                this.empresasSeleccionadas.splice(index, 1)
            } else {
                this.empresasSeleccionadas.push(compania.id)
            }
            this.updateSelectAllCompaniesModal()
        },

        toggleSelectAllCompaniesModal() {
            this.selectAllCompaniesModal = !this.selectAllCompaniesModal
            if (this.selectAllCompaniesModal) {
                const selectedIds = this.filteredCompany.map(c => c.id)
                selectedIds.forEach(id => {
                    if (!this.empresasSeleccionadas.includes(id)) {
                        this.empresasSeleccionadas.push(id)
                    }
                })
            } else {
                const filteredIds = this.filteredCompany.map(c => c.id)
                this.empresasSeleccionadas = this.empresasSeleccionadas.filter(id => !filteredIds.includes(id))
            }
        },

        updateSelectAllCompaniesModal() {
            if (this.filteredCompany.length === 0) {
                this.selectAllCompaniesModal = false
                return
            }
            this.selectAllCompaniesModal = this.filteredCompany.every(c => this.empresasSeleccionadas.includes(c.id))
        },

        openEmpresasModal() {
            this.empresasSeleccionadas = []
            this.selectAllCompaniesModal = false
            this.showEmpresasModal = true
            this.updateSelectAllCompaniesModal()
        },

        closeEmpresasModal() {
            if (this.isSavingCompanies) return
            this.showEmpresasModal = false
            if (this.fromButtonGenerate) {
                this.fromButtonGenerate = false
            }
        },

        confirmEmpresasSelectionModal() {
            if (this.isSavingCompanies) return
            if (this.empresasSeleccionadas.length === 0) {
                this.$toast.warning(
                    this.$store.state._language == "es-ES"
                        ? "Por favor seleccione al menos una empresa"
                        : "Please select at least one company"
                )
                return
            }

            this.isSavingCompanies = true
            this.showEmpresasModal = false
            this.isSavingCompanies = false

            this.listConsolidado = []
            this.datosConsultados = false

            setTimeout(() => {
                this.consultarDatos()
            }, 300)
        },

        // ==================== MÉTODOS DE MONEDA ====================
        getNombreMonedaConsolidado(tipo = 'funcional1') {
            const funcionalEsperada = tipo === 'funcional2' ? 2 : 1
            const moneda = (this.currency || []).find((item) => Number(item.isFuncional) === funcionalEsperada)
            if (!moneda) return ''
            return moneda?.nombre || moneda?.acronimo || ''
        },

        getMonedaConsolidadoParametro() {
            return this.monedaConsolidadoSeleccion === 'funcional2' ? 2 : 1
        },

        normalizaSelectorMonedaConsolidado() {
            const opciones = this.monedaConsolidadoOptions.map((item) => item.value)
            if (opciones.length === 0) {
                this.monedaConsolidadoSeleccion = 'funcional1'
                return
            }
            if (!opciones.includes(this.monedaConsolidadoSeleccion)) {
                this.monedaConsolidadoSeleccion = opciones[0]
            }
        },

        onCambioMonedaConsolidado() {
            this.normalizaSelectorMonedaConsolidado()
            if (this.mostrarConsolidado && this.datosConsultados) {
                this.consultarDatos()
            }
        },

        // ==================== MÉTODOS DE FILTROS ====================
        onFiltroChange() {
            this.datosConsultados = false
            this.listReportesGuardados = []
            this.listReportesComparativo = []
            this.listFilasManuales = []
            this.listConsolidado = []
            this.columnasConsolidado = []
            this.empresasConsolidadoNombres = {}
            this.empresasConsolidadoNombresDiff = {}
            this.filaSeleccionada = null
            this.showModalValor = false
        },

        filtraCompaniasPorGrupo(valor = null) {
            const grupoIdSeleccionado = valor !== null ? valor : this.grupoId

            this.onFiltroChange()
            this.companyId = null
            this.empresasSeleccionadas = []
            this.selectAllCompaniesModal = false

            if (grupoIdSeleccionado === 'todos' || !grupoIdSeleccionado) {
                this.filteredCompany = [...this.listCompany]
            } else {
                const grupoIdStr = grupoIdSeleccionado.toString()
                this.filteredCompany = this.listCompany.filter(compania => {
                    if (!compania?.id_grupos) return false
                    const gruposCompania = compania.id_grupos.split(',').map(id => id.trim())
                    return gruposCompania.includes(grupoIdStr)
                })
            }
        },

        seleccionaCompania() {
            this.onFiltroChange()
        },

        // ==================== MÉTODOS DE CONSOLIDADO ====================
        getIndiceColumnaConsolidado(col = '') {
            const match = String(col || '').match(/(\d+)/)
            return match ? Number(match[1]) : 0
        },

        getValorColumnaConsolidado(item = {}, col = '') {
            const index = this.getIndiceColumnaConsolidado(col)
            if (!index) return 0
            const sufijo = this.monedaConsolidadoSeleccion === 'funcional2' ? '_m2' : ''
            const candidatos = [
                `prom${index}${sufijo}`,
                `sal${index}${sufijo}`,
                `fun${index}${sufijo}`,
                `c${index}${sufijo}`,
                `prom${index}`,
                `sal${index}`,
                `fun${index}`,
                `c${index}`
            ]
            for (const campo of candidatos) {
                if (item[campo] !== undefined && item[campo] !== null) {
                    return parseFloat(item[campo]) || 0
                }
            }
            return 0
        },

        getDiffCambioConsolidado(item = {}, col = '') {
            const index = this.getIndiceColumnaConsolidado(col)
            if (!index) return 0
            
            const sufijo = this.monedaConsolidadoSeleccion === 'funcional2' ? '_m2' : ''
            
            let promValue = 0
            const promCandidatos = [`prom${index}${sufijo}`, `prom${index}`]
            for (const campo of promCandidatos) {
                if (item[campo] !== undefined && item[campo] !== null) {
                    promValue = parseFloat(item[campo]) || 0
                    break
                }
            }
            
            let cieValue = 0
            const cieCandidatos = [`cie${index}${sufijo}`, `cie${index}`]
            for (const campo of cieCandidatos) {
                if (item[campo] !== undefined && item[campo] !== null) {
                    cieValue = parseFloat(item[campo]) || 0
                    break
                }
            }
            
            // Para la diferencia de cambio, usamos cie - prom
            return cieValue - promValue
        },

        getTotalDiffCambioConsolidado(item = {}) {
            if (!item) return 0
            let totalDiff = 0
            const sufijo = this.monedaConsolidadoSeleccion === 'funcional2' ? '_m2' : ''
            
            for (let i = 1; i <= this.columnasConsolidado.length; i++) {
                let cieValue = 0
                const cieCandidatos = [`cie${i}${sufijo}`, `cie${i}`]
                for (const campo of cieCandidatos) {
                    if (item[campo] !== undefined && item[campo] !== null) {
                        cieValue = parseFloat(item[campo]) || 0
                        break
                    }
                }
                
                let promValue = 0
                const promCandidatos = [`prom${i}${sufijo}`, `prom${i}`]
                for (const campo of promCandidatos) {
                    if (item[campo] !== undefined && item[campo] !== null) {
                        promValue = parseFloat(item[campo]) || 0
                        break
                    }
                }
                
                totalDiff += (cieValue - promValue)
            }
            return totalDiff
        },

        getValorConsolidadoResumen(item = {}, tipo = 'total_consolidado') {
            const sufijo = this.monedaConsolidadoSeleccion === 'funcional2' ? '_m2' : ''
            const mapa = {
                ajustes: [`ajustes_prom${sufijo}`, `ajustes${sufijo}`, 'ajustes'],
                total_consolidado: [`total_consolidado_prom${sufijo}`, `total_consolidado${sufijo}`, 'total_consolidado', `total_prom${sufijo}`, `total${sufijo}`, 'total'],
                combinado: [`combinado_prom${sufijo}`, `combinado${sufijo}`, 'combinado'],
                total_combinado: [`total_combinado_prom${sufijo}`, `total_combinado${sufijo}`, 'total_combinado']
            }
            const candidatos = mapa[tipo] || [tipo]
            for (const campo of candidatos) {
                if (item[campo] !== undefined && item[campo] !== null) {
                    return parseFloat(item[campo]) || 0
                }
            }
            return 0
        },

        obtenerNombreColumnaSaldo(col) {
            const nombreBase = this.empresasConsolidadoNombres[col] || col.toUpperCase();
            return nombreBase;
        },

        obtenerNombreColumnaDiffCambio(col) {
            const nombreBase = this.empresasConsolidadoNombresDiff[col] || col.toUpperCase();
            return nombreBase;
        },

        getEmpresasDeGrupo(grupoId) {
            if (!grupoId || grupoId === 'todos') {
                return this.filteredCompany.map(c => c.id)
            }
            const grupoIdStr = String(grupoId).trim()
            return this.listCompany
                .filter(c => {
                    if (!c?.id_grupos) return false
                    const grupos = String(c.id_grupos).split(',').map(id => id.trim())
                    return grupos.includes(grupoIdStr)
                })
                .map(c => c.id)
        },

        beforeUnmount() {
            this.stopProgressAnimation()
        },

        startProgressAnimation(estimatedTime = 40) {
            this.stopProgressAnimation()

            this.progressStartTime = Date.now()
            this.progressEstimatedTime = estimatedTime
            this.generatingProgress = 0
            this.progressCurrentMessageIndex = 0

            this.progressMessageInterval = setInterval(() => {
                this.progressCurrentMessageIndex =
                    (this.progressCurrentMessageIndex + 1) % this.progressMessages.length
            }, 3000)

            this.progressInterval = setInterval(() => {
                const elapsed = (Date.now() - this.progressStartTime) / 1000
                const calculated = Math.min((elapsed / this.progressEstimatedTime) * 100, 99)
                const smooth = Math.max(calculated, this.generatingProgress + 0.5)
                this.generatingProgress = Math.round(Math.min(smooth, 99))
            }, 500)
        },

        setProgress(percent, message = null, subMessage = null) {
            if (typeof percent === 'number' && percent >= 0 && percent <= 100) {
                if (percent > this.generatingProgress) {
                    this.generatingProgress = Math.round(percent)
                }
            }
            if (message !== null) this.generatingMessage = message
            if (subMessage !== null) this.generatingSubMessage = subMessage
        },

        completeProgress() {
            this.generatingProgress = 100
            setTimeout(() => this.stopProgressAnimation(), 500)
        },

        stopProgressAnimation() {
            if (this.progressInterval) {
                clearInterval(this.progressInterval)
                this.progressInterval = null
            }
            if (this.progressMessageInterval) {
                clearInterval(this.progressMessageInterval)
                this.progressMessageInterval = null
            }
        },

        cerrarProgreso() {
            this.setProgress(100, '¡Completado!', 'Descarga lista')
            setTimeout(() => {
                this.stopProgressAnimation()
                this.showGeneratingModal = false
            }, 600)
        },

        // ==================== MÉTODO DE CONSULTA PRINCIPAL ====================
        async consultarDatos() {
            if (this.selectedViewOption === 'consolidado' && this.empresasSeleccionadas.length === 0) {
                this.fromButtonGenerate = true
                this.openEmpresasModal()
                return
            }

            if (!this.selVigencia) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione una vigencia" : "Please select a validity")
                return
            }
            if (!this.selReporte) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione un reporte" : "Please select a report")
                return
            }
            if (!this.companyId && !this.mostrarConsolidado) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione una compañía" : "Please select a company")
                return
            }

            this.isLoading = true
            this.datosConsultados = true

            try {
                this.listReportesGuardados = []
                this.listReportesComparativo = []
                this.listFilasManuales = []
                this.listConsolidado = []

                if (this.mostrarConsolidado) {
                    const empresasParaConsolidar = this.empresasSeleccionadas.length > 0
                        ? [...this.empresasSeleccionadas]
                        : [this.companyId]
                    await this.cargarConsolidado(empresasParaConsolidar)
                    this.empresasSeleccionadas = []
                    this.selectAllCompaniesModal = false
                    
                    if (this.listConsolidado.length === 0) {
                        this.$toast.warning(this.$store.state._language == "es-ES" ? "No existe información consolidada para las empresas seleccionadas" : "No consolidated information exists for the selected companies")
                    } else {
                        this.$toast.success(this.$store.state._language == "es-ES" ? "Reporte consolidado cargado correctamente" : "Consolidated report loaded successfully")
                    }
                } else {
                    if (this.mostrarReporte) {
                        await this.cargarReporteComparativo()
                    }
                    if (this.mostrarInformacion || this.mostrarAjusteConsol || this.mostrarAjusteCombinado) {
                        await this.cargarFilasManuales()
                    }

                    if (this.mostrarReporte && this.listReportesComparativo.length === 0) {
                        this.$toast.warning(this.$store.state._language == "es-ES" ? "No existe información de Reporte para esta compañía" : "No Report information exists for this company")
                    }
                    if ((this.mostrarInformacion || this.mostrarAjusteConsol || this.mostrarAjusteCombinado) && this.listFilasManuales.length === 0) {
                        this.$toast.warning(this.$store.state._language == "es-ES" ? "No existen filas de tipo manual para esta configuración" : "No manual rows exist for this configuration")
                    }
                    if (this.mostrarReporte && this.listReportesComparativo.length > 0) {
                        this.$toast.success(this.$store.state._language == "es-ES" ? "Reporte cargado correctamente" : "Report loaded successfully")
                    }
                    if ((this.mostrarInformacion || this.mostrarAjusteConsol || this.mostrarAjusteCombinado) && this.listFilasManuales.length > 0) {
                        this.$toast.success(this.$store.state._language == "es-ES" ? "Información manual cargada correctamente" : "Manual information loaded successfully")
                    }
                }
            } catch (error) {
                console.error("Error cargando datos:", error)
                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar los datos" : "Error loading data")
            } finally {
                this.isLoading = false
            }
        },

        // ==================== MÉTODOS DE CARGA DE DATOS ====================
        async cargarReporteComparativo() {
            try {
                const response = await Balance.obtenerReporteComparativoOri(
                    this.selReporte,
                    this.companyId,
                    this.selVigencia
                )
                if (response.data && response.data.data) {
                    this.listReportesComparativo = response.data.data
                    if (response.data.vigencias) {
                        this.vigenciaActual = response.data.vigencias.actual
                        this.vigenciaAnterior = response.data.vigencias.anterior
                    }
                } else {
                    this.listReportesComparativo = []
                }
            } catch (error) {
                console.error("Error cargando reporte comparativo:", error)
                this.listReportesComparativo = []
                throw error
            }
        },

        async cargarFilasManuales() {
            try {
                const formulacionObjetivo = this.mostrarAjusteCombinado ? 'mc' : (this.mostrarAjusteConsol ? 'ac' : 'm')
                const response = await Balance.obtenerFilasPrincipalesOri(
                    this.selReporte,
                    this.companyId,
                    this.selVigencia
                )
                let filas = response.data.data || []

                if (filas.length > 0 && typeof filas[0] === 'object' && !Array.isArray(filas[0])) {
                    const primerElemento = filas[0]
                    const valores = Object.values(primerElemento)
                    filas = valores.filter(item => item && item.id)
                }

                if (filas.length === 0) {
                    const añoActual = parseInt(this.selVigencia.substring(0, 4))
                    const mes = this.selVigencia.substring(4, 6)
                    const vigenciaAnterior = `${añoActual - 1}${mes}`
                    const userId = this.$store.state.userId || localStorage.getItem('userId')
                    await Balance.copiarConfiguracionOri(
                        this.selReporte,
                        this.companyId,
                        vigenciaAnterior,
                        this.selVigencia,
                        userId
                    )
                    const newResponse = await Balance.obtenerFilasPrincipalesOri(
                        this.selReporte,
                        this.companyId,
                        this.selVigencia
                    )
                    filas = newResponse.data.data || []
                    if (filas.length > 0 && typeof filas[0] === 'object' && !Array.isArray(filas[0])) {
                        const primerElemento = filas[0]
                        const valores = Object.values(primerElemento)
                        filas = valores.filter(item => item && item.id)
                    }
                }

                if (filas.length === 0) {
                    this.listFilasManuales = []
                    return
                }

                const filasConFormulaciones = await Promise.all(
                    filas.map(async (filaItem) => {
                        const formulacionesResponse = this.mostrarAjusteConsol
                            ? await Balance.obtenerFormulacionesOriConsol(
                                this.selReporte,
                                this.companyId,
                                this.selVigencia,
                                filaItem.orden
                            )
                            : this.mostrarAjusteCombinado
                                ? await Balance.obtenerFormulacionesOriCombinado(
                                    this.selReporte,
                                    this.companyId,
                                    this.selVigencia,
                                    filaItem.orden
                                )
                                : await Balance.obtenerFormulacionesOri(
                                    this.selReporte,
                                    this.companyId,
                                    this.selVigencia,
                                    filaItem.orden
                                )
                        const formulaciones = formulacionesResponse.data.data || []
                        const formulacionManual = formulaciones.find(
                            f => (f.formulacion || '').toString().trim().toLowerCase() === formulacionObjetivo
                        )
                        if (formulacionManual) {
                            return {
                                id: filaItem.id,
                                orden: filaItem.orden,
                                descripcion: filaItem.descripcion,
                                formulaciones: formulaciones,
                                formulacionId: formulacionManual.id,
                                valorGuardado: formulacionManual.valor !== null ? parseFloat(formulacionManual.valor) : 0,
                                funcional1Guardado: formulacionManual.funcional1 !== null ? parseFloat(formulacionManual.funcional1) : 0
                            }
                        }
                        return null
                    })
                )
                this.listFilasManuales = filasConFormulaciones.filter(filaItem => filaItem !== null)
            } catch (error) {
                console.error("Error cargando filas manuales:", error)
                this.listFilasManuales = []
                throw error
            }
        },

        async cargarConsolidado(empresasIds = []) {
            try {
                const empresasStr = empresasIds.join(',')
                const response = await Balance.obtenerReporteConsolidadoOri(
                    this.selReporte,
                    empresasStr,
                    this.selVigencia,
                    this.getMonedaConsolidadoParametro()
                )
                if (response.data && response.data.data) {
                    let datos = response.data.data
                    if (datos && typeof datos === 'object' && !Array.isArray(datos)) {
                        const keys = Object.keys(datos)
                        if (keys.length > 0 && !isNaN(keys[0])) {
                            datos = Object.values(datos)
                        } else {
                            datos = [datos]
                        }
                    }

                    const primeraFila = datos[0] || {}
                    const indicesColumnas = new Set()
                    Object.keys(primeraFila).forEach((key) => {
                        // Buscar patrones como sal1, sal2, prom1, prom2, etc.
                        const match = key.match(/^(sal|prom|fun|cie)(\d+)(?:_m2)?$/)
                        if (match) {
                            indicesColumnas.add(Number(match[2]))
                        }
                    })

                    const columnasEmpresa = Array.from(indicesColumnas)
                        .sort((a, b) => a - b)
                        .map((index) => `c${index}`)

                    const empresasNombres = {}
                    const empresasNombresDiff = {}
                    empresasIds.forEach((empId, idx) => {
                        const empresa = this.listCompany.find(c => c.id == empId)
                        if (empresa) {
                            const nombreBase = empresa.acronym || empresa.nombre
                            empresasNombres[`c${idx + 1}`] = nombreBase + ' Saldo'
                            empresasNombresDiff[`c${idx + 1}`] = nombreBase + ' Diferencia Cambio'
                        }
                    })

                    this.columnasConsolidado = columnasEmpresa
                    this.empresasConsolidadoNombres = empresasNombres
                    this.empresasConsolidadoNombresDiff = empresasNombresDiff

                    // Mapear los datos para incluir las claves sal1, sal2, etc.
                    this.listConsolidado = datos.map(item => {
                        const filaTransformada = {
                            ...item,
                            id: item.orden,
                            orden: item.orden,
                            descripcion: item.descripcion,
                            ajustes: parseFloat(item.ajustes) || 0,
                            total_consolidado: parseFloat(item.total_consolidado) || 0,
                            combinado: parseFloat(item.combinado) || 0,
                            total_combinado: parseFloat(item.total_combinado) || 0
                        }

                        // Asegurar que los campos sal1, sal2, etc. existan
                        indicesColumnas.forEach(index => {
                            const key = `sal${index}`
                            if (filaTransformada[key] === undefined || filaTransformada[key] === null) {
                                filaTransformada[key] = 0
                            }
                        })

                        return filaTransformada
                    })
                } else {
                    this.listConsolidado = []
                    this.columnasConsolidado = []
                    this.empresasConsolidadoNombres = {}
                    this.empresasConsolidadoNombresDiff = {}
                }
            } catch (error) {
                console.error("Error cargando consolidado:", error)
                this.listConsolidado = []
                this.columnasConsolidado = []
                this.empresasConsolidadoNombres = {}
                this.empresasConsolidadoNombresDiff = {}
                throw error
            }
        },

        // ==================== MÉTODOS DE MODAL DE VALOR MANUAL ====================
        abrirModalValor(fila) {
            if (this.isVigenciaBloqueada) {
                this.$toast.error(this.$store.state._language == "es-ES" ? "La vigencia seleccionada está deshabilitada para edición." : "The selected validity is disabled for editing.")
                return
            }
            this.filaSeleccionada = fila
            this.valorIngresado = fila.valorGuardado !== null ? fila.valorGuardado : null
            this.funcional1Ingresado = fila.funcional1Guardado !== null ? fila.funcional1Guardado : null
            this.showModalValor = true
        },

        cerrarModalValor() {
            this.showModalValor = false
            this.filaSeleccionada = null
            this.valorIngresado = null
            this.funcional1Ingresado = null
        },

        async guardarValorManual() {
            if (this.isVigenciaBloqueada) {
                this.$toast.error(this.$store.state._language == "es-ES" ? "La vigencia seleccionada está deshabilitada para edición." : "The selected validity is disabled for editing.")
                return
            }
            if (!this.filaSeleccionada || this.filaSeleccionada.orden === undefined || this.filaSeleccionada.orden === null) {
                this.$toast.error(this.$store.state._language == "es-ES" ? "No hay una fila válida seleccionada para guardar." : "No valid row selected to save.")
                return
            }
            if (this.valorIngresado === null || this.valorIngresado === '') {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Ingrese un valor válido" : "Enter a valid value")
                return
            }
            if (this.funcional1Ingresado === null || this.funcional1Ingresado === '') {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Ingrese un valor funcional válido" : "Enter a valid functional value")
                return
            }

            const userId = this.$store.state.userId || localStorage.getItem('userId')
            if (!userId) {
                this.$toast.error(this.$store.state._language == "es-ES" ? "No se encontró el ID de usuario" : "User ID not found")
                return
            }

            this.isLoading = true
            try {
                const formulacionObjetivo = this.mostrarAjusteCombinado ? 'mc' : (this.mostrarAjusteConsol ? 'ac' : 'm')

                const payload = {
                    accion: 'UPDATE_FORMULACION',
                    id: this.filaSeleccionada.formulacionId || null,
                    codReporte: parseInt(this.selReporte, 10),
                    vigencia: this.selVigencia,
                    id_compania: parseInt(this.companyId, 10),
                    orden: parseInt(this.filaSeleccionada.orden, 10),
                    reporte: 'ORI',
                    niif: null,
                    cuentas: null,
                    contable: 0,
                    actual: 1,
                    operacion: '+',
                    formulacion: formulacionObjetivo,
                    valor: parseFloat(this.valorIngresado),
                    funcional1: parseFloat(this.funcional1Ingresado),
                    esConsol: this.mostrarAjusteConsol === true,
                    esCombinado: this.mostrarAjusteCombinado === true,
                    guardar_valor_manual: true,
                    u_crea: parseInt(userId, 10),
                    u_modifica: parseInt(userId, 10)
                }

                await Balance.gestionarFormulacionesOri(payload)
                this.filaSeleccionada.valorGuardado = parseFloat(this.valorIngresado)
                this.filaSeleccionada.funcional1Guardado = parseFloat(this.funcional1Ingresado)
                this.filaSeleccionada.formulacionId = this.filaSeleccionada.formulacionId || (payload.id)

                this.$toast.success(this.$store.state._language == "es-ES" ? "Valor guardado correctamente" : "Value saved successfully")
                this.cerrarModalValor()
            } catch (error) {
                console.error("Error guardando valor:", error)
                this.$toast.error(error.response?.data?.message || this.$store.state._language == "es-ES" ? "Error al guardar el valor" : "Error saving value")
            } finally {
                this.isLoading = false
            }
        },

        // ==================== MÉTODOS DE TÍTULO ====================
        f_titulo() {
            if (this.$store.state._language == "es-ES") {
                this.tituloConsolidado = "Estado de Otros Resultados Integrales"
            } else {
                this.tituloConsolidado = "Statement of Other Comprehensive Income"
            }
            return this.tituloConsolidado
        },

        // ==================== MÉTODOS DE FORMATEO ====================
        formatCurrency(value) {
            if (value === null || value === undefined) return '0'
            return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })?.format(value)
        },

        // ==================== MÉTODOS DE EXPORTACIÓN ====================
        async exportarExcel() {
            if (!this.listReportesGuardados.length) return

            this.showGeneratingModal = true
            this.startProgressAnimation(20)
            this.setProgress(5, 'Preparando exportación...', 'Iniciando proceso')

            try {
                const workbook = new XLSX.Workbook()
                const worksheet = workbook.addWorksheet("ORI Balance")

                this.setProgress(30, 'Procesando datos...', 'Organizando información')

                worksheet.mergeCells('A1:D1')
                worksheet.getCell('A1').value = this.f_titulo()
                worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
                worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

                const headers = ['Descripción', 'Local', 'Funcional', 'Interna']
                const headerRow = worksheet.addRow(headers)
                headerRow.eachCell((cell) => {
                    cell.font = { name: "Calibri", size: 11, bold: true }
                    cell.alignment = { horizontal: "center", vertical: "middle" }
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
                    cell.border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    }
                })

                this.setProgress(60, 'Escribiendo filas...', 'Agregando registros')

                this.listReportesGuardados.forEach(item => {
                    worksheet.addRow([
                        item.descripcion || '-',
                        item.saldo_local || 0,
                        item.saldo_funcional || 0,
                        item.saldo_interna || 0
                    ])
                })

                worksheet.columns = [
                    { width: 50 },
                    { width: 20 },
                    { width: 20 },
                    { width: 20 }
                ]

                this.setProgress(90, 'Generando archivo Excel...', 'Escribiendo buffer')

                const file = await workbook.xlsx.writeBuffer()
                const downloadLink = document.createElement("a")
                downloadLink.download = `ORI_Balance_${this.selVigencia}.xlsx`
                downloadLink.href = window.URL.createObjectURL(
                    new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                )
                downloadLink.style.display = "none"
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink)
                window.URL.revokeObjectURL(downloadLink.href)

                this.cerrarProgreso()
                this.$toast.success(this.$store.state._language == "es-ES" ? "Excel exportado correctamente" : "Excel exported successfully")
            } catch (error) {
                console.error("Error exportando:", error)
                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al exportar Excel" : "Error exporting Excel")

                this.stopProgressAnimation()
                this.showGeneratingModal = false
            }
        },

        async exportarExcelReporte() {
            if (!this.listReportesComparativo.length) return
            this.$toast.info(this.$store.state._language == "es-ES" ? "Generando Excel..." : "Generating Excel...")
            try {
                const workbook = new XLSX.Workbook()
                const worksheet = workbook.addWorksheet("ORI Reporte")

                worksheet.mergeCells('A1:B1')
                worksheet.getCell('A1').value = this.f_titulo()
                worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
                worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

                const headers = ['Descripción', this.vigenciaActual || 'Saldo Actual']
                const headerRow = worksheet.addRow(headers)
                headerRow.eachCell((cell) => {
                    cell.font = { name: "Calibri", size: 11, bold: true }
                    cell.alignment = { horizontal: "center", vertical: "middle" }
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
                    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                })

                this.listReportesComparativo.forEach(item => {
                    worksheet.addRow([
                        item.descripcion || '-',
                        item.saldo_actual || 0
                    ])
                })

                worksheet.columns = [{ width: 50 }, { width: 25 }]
                const file = await workbook.xlsx.writeBuffer()
                const downloadLink = document.createElement("a")
                downloadLink.download = `ORI_Reporte_${this.selVigencia}.xlsx`
                downloadLink.href = window.URL.createObjectURL(
                    new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                )
                downloadLink.style.display = "none"
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink)
                window.URL.revokeObjectURL(downloadLink.href)
                this.$toast.success(this.$store.state._language == "es-ES" ? "Excel exportado correctamente" : "Excel exported successfully")
            } catch (error) {
                console.error("Error exportando:", error)
                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al exportar Excel" : "Error exporting Excel")
            }
        },

        async exportarExcelManual() {
            if (!this.listFilasManuales.length) return
            this.$toast.info(this.$store.state._language == "es-ES" ? "Generando Excel..." : "Generating Excel...")
            try {
                const workbook = new XLSX.Workbook()
                const worksheet = workbook.addWorksheet("ORI Manual")

                worksheet.mergeCells('A1:C1')
                worksheet.getCell('A1').value = this.f_titulo()
                worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
                worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

                const headers = ['Descripción', 'Valor', 'Funcional']
                const headerRow = worksheet.addRow(headers)
                headerRow.eachCell((cell) => {
                    cell.font = { name: "Calibri", size: 11, bold: true }
                    cell.alignment = { horizontal: "center", vertical: "middle" }
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
                    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                })

                this.listFilasManuales.forEach(item => {
                    worksheet.addRow([
                        item.descripcion || '-',
                        item.valorGuardado || 0,
                        item.funcional1Guardado || 0
                    ])
                })

                worksheet.columns = [{ width: 50 }, { width: 20 }, { width: 20 }]
                const file = await workbook.xlsx.writeBuffer()
                const downloadLink = document.createElement("a")
                downloadLink.download = `ORI_Manual_${this.selVigencia}.xlsx`
                downloadLink.href = window.URL.createObjectURL(
                    new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                )
                downloadLink.style.display = "none"
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink)
                window.URL.revokeObjectURL(downloadLink.href)
                this.$toast.success(this.$store.state._language == "es-ES" ? "Excel exportado correctamente" : "Excel exported successfully")
            } catch (error) {
                console.error("Error exportando:", error)
                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al exportar Excel" : "Error exporting Excel")
            }
        },

        async exportarExcelConsolidado() {
            if (!this.listConsolidado.length) return

            this.showGeneratingModal = true
            this.startProgressAnimation(25)
            this.setProgress(5, 'Preparando exportación...', 'Iniciando proceso')

            try {
                const workbook = new XLSX.Workbook()
                const worksheet = workbook.addWorksheet("ORI Consolidado")

                this.setProgress(15, 'Calculando columnas...', 'Organizando estructura')

                const totalColumnas = 1 + (this.columnasConsolidado.length * 2) + 3 + (this.vistaConsolidado === "Combinado" ? 2 : 0)

                const getExcelColumnName = (columnNumber) => {
                    let dividend = columnNumber
                    let columnName = ""
                    while (dividend > 0) {
                        const modulo = (dividend - 1) % 26
                        columnName = String.fromCharCode(65 + modulo) + columnName
                        dividend = Math.floor((dividend - modulo) / 26)
                    }
                    return columnName
                }
                const ultimaColumna = getExcelColumnName(totalColumnas)

                const userName = this.$store?.state?.userName || localStorage.getItem('userName') || 'Usuario'
                const reporteNombre = this.listReporte.find(r => r.codigo == this.selReporte)?.nombre || 'ORI'

                // Título principal
                worksheet.mergeCells(`A1:${ultimaColumna}1`)
                worksheet.getCell('A1').value = "ESTADOS DE OTROS RESULTADOS INTEGRALES - ORI"
                worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }
                worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }

                // Fila 2: Vigencia
                worksheet.mergeCells(`A2:${ultimaColumna}2`)
                worksheet.getCell('A2').value = `Vigencia: ${this.selVigencia} | Consolidado de múltiples empresas`
                worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true }
                worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" }

                // Fila 3: Generado por y Reporte
                worksheet.mergeCells(`A3:${ultimaColumna}3`)
                const today = new Date()
                const fechaFormateada = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
                worksheet.getCell('A3').value = `Generado: ${fechaFormateada} por ${userName} | Reporte: ${reporteNombre}`
                worksheet.getCell('A3').font = { name: "Calibri", size: 11, bold: true }
                worksheet.getCell('A3').alignment = { horizontal: "center", vertical: "middle" }

                worksheet.addRow([])

                this.setProgress(30, 'Construyendo encabezados...', 'Preparando columnas')

                // Construir encabezados dinámicamente
                const headers = ['Descripción / NIIF (IFRS)']

                this.columnasConsolidado.forEach(col => {
                    headers.push(this.obtenerNombreColumnaSaldo(col))
                    headers.push(this.obtenerNombreColumnaDiffCambio(col))
                })

                headers.push('Ajustes', 'Consolidado', 'Consolidado Diferencia Cambio')
                if (this.vistaConsolidado === "Combinado") {
                    headers.push('Combinado', 'Total Combinado')
                }

                const headerRow = worksheet.addRow(headers)
                headerRow.eachCell((cell) => {
                    cell.font = { name: "Calibri", size: 11, bold: true }
                    cell.alignment = { horizontal: "center", vertical: "middle" }
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
                    cell.border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    }
                })

                // Configurar ancho de columnas
                const columnWidths = [50]
                for (let i = 0; i < this.columnasConsolidado.length; i++) {
                    columnWidths.push(25, 25)
                }
                columnWidths.push(25, 25, 25)
                if (this.vistaConsolidado === "Combinado") {
                    columnWidths.push(25, 25)
                }
                worksheet.columns = columnWidths.map(width => ({ width }))

                this.setProgress(50, 'Escribiendo filas...', 'Agregando registros')

                // Agregar datos
                const totalFilas = this.listConsolidado.length
                this.listConsolidado.forEach((item, idx) => {
                    const rowData = [item.descripcion || '-']

                    this.columnasConsolidado.forEach(col => {
                        rowData.push(this.getValorColumnaConsolidado(item, col) || 0)
                        rowData.push(this.getDiffCambioConsolidado(item, col) || 0)
                    })

                    rowData.push(this.getValorConsolidadoResumen(item, 'ajustes') || 0)
                    rowData.push(this.getValorConsolidadoResumen(item, 'total_consolidado') || 0)
                    rowData.push(this.getTotalDiffCambioConsolidado(item) || 0)

                    if (this.vistaConsolidado === "Combinado") {
                        rowData.push(this.getValorConsolidadoResumen(item, 'combinado') || 0)
                        rowData.push(this.getValorConsolidadoResumen(item, 'total_combinado') || 0)
                    }

                    const row = worksheet.addRow(rowData)
                    row.getCell(1).alignment = { horizontal: "left", vertical: "middle" }
                    row.getCell(1).border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    }
                    for (let i = 2; i <= rowData.length; i++) {
                        row.getCell(i).alignment = { horizontal: "right", vertical: "middle" }
                        row.getCell(i).border = {
                            top: { style: "thin" },
                            left: { style: "thin" },
                            bottom: { style: "thin" },
                            right: { style: "thin" }
                        }
                    }

                    // Actualizar progreso entre 50% y 90%
                    if (totalFilas > 0) {
                        const pct = 50 + Math.round(((idx + 1) / totalFilas) * 40)
                        if (pct % 10 === 0) {
                            this.setProgress(
                                pct,
                                'Escribiendo filas...',
                                `Fila ${idx + 1} de ${totalFilas}`
                            )
                        }
                    }
                })

                this.setProgress(90, 'Generando archivo Excel...', 'Escribiendo buffer')

                const file = await workbook.xlsx.writeBuffer()
                const downloadLink = document.createElement("a")
                downloadLink.download = `ORI_Consolidado_${this.selVigencia}.xlsx`
                downloadLink.href = window.URL.createObjectURL(
                    new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                )
                downloadLink.style.display = "none"
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink)
                window.URL.revokeObjectURL(downloadLink.href)

                this.cerrarProgreso()
                this.$toast.success(this.$store.state._language == "es-ES" ? "Excel exportado correctamente" : "Excel exported successfully")
            } catch (error) {
                console.error("Error exportando:", error)
                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al exportar Excel" : "Error exporting Excel")

                this.stopProgressAnimation()
                this.showGeneratingModal = false
            }
        },

        // ==================== MÉTODOS DE CONTROL DE BOTONES ====================
        async loadButtonControlsFromDb() {
            const defaultControls = {
                Consolidado: true,
                Reporte: true,
                Informacion: true,
                AjusteConsol: true,
                AjusteCombinado: true,
                SelectorMoneda: true,
                MonedaFuncional1: true,
                MonedaFuncional2: true
            }
            const controlMap = {
                300: "Consolidado",
                700: "Reporte",
                720: "Informacion",
                730: "AjusteConsol",
                740: "AjusteCombinado",
                600: "SelectorMoneda",
                610: "MonedaFuncional1",
                620: "MonedaFuncional2"
            }
            try {
                const roleId = Number(this.$store.state.userRole) || 0
                const response = await BotonesControl.getBotonesControl("REPORTEORI", roleId)
                const botones = Array.isArray(response.data.botones) ? response.data.botones : []
                const controls = { ...defaultControls }
                botones.forEach((item) => {
                    const key = controlMap[Number(item.id_boton)]
                    if (!key) return
                    controls[key] = item.enabled !== false
                })
                this.$store.commit("setComponentControls", {
                    componentName: "ReporteORI",
                    controls
                })
            } catch (error) {
                console.log("Error cargando visibilidad de botones ORI:", error)
            } finally {
                if (!this.isConsolidadoVisible) {
                    this.mostrarConsolidado = false
                }
                this.normalizaSelectorMonedaConsolidado()
            }
        },

        goBack() {
            this.$router.back()
        },

        // ==================== MÉTODOS DE CARGA INICIAL ====================
        async loadUserCompanies() {
            try {
                const userResult = await Balance.leaCompaniaUsuario()
                const companiaUsuario = userResult.data.companiaUsuario
                const companiesResult = await Company.getAllCompanies()
                const allCompanies = companiesResult.data.companies
                const filteredCompanies = allCompanies.filter((company) => {
                    if (this.$store.state.userRole == 1) return true
                    return companiaUsuario?.find(
                        (userCompany) =>
                            userCompany.id_usuario == this.$store.state.userId &&
                            userCompany.id_compania == company.id
                    )
                })
                this.listCompany = filteredCompanies
                this.filteredCompany = filteredCompanies
            } catch (err) {
                console.error("Error loading companies:", err)
            }
        },

        async loadVigencias() {
            try {
                const result = await PlanCuentas.getVigenciaPlancuentas()
                this.listVigencia = result.data.getVigencia
            } catch (err) {
                console.error("Error loading vigencias:", err)
            }
        },

        async loadReportTypes() {
            try {
                const res = await TipoReporte.getAllTipoReporte()
                this.listReporte = res.data.typeReport
            } catch (err) {
                console.error("Error loading report types:", err)
            }
        },

        async loadGrupos() {
            try {
                const result = await Grupo.getAllGrupos()
                this.listGrupos = result.data.grupos
            } catch (err) {
                console.error("Error loading grupos:", err)
            }
        }
    },
    async mounted() {
        this.isLoading = true
        await this.loadButtonControlsFromDb()

        await Promise.all([
            this.loadUserCompanies(),
            this.loadVigencias(),
            this.loadReportTypes(),
            this.loadGrupos(),
            Currency.getAllCurrency().then((result) => {
                this.currency = result.data.currency || []
                this.normalizaSelectorMonedaConsolidado()
            }).catch(() => {})
        ])

        this.isLoading = false
        this.f_titulo()
    },
}
</script>

<style src="../main.css"></style>

<style scoped>
/* ========== ESTILOS DE FILTROS PRINCIPALES ========== */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

/* ========== DROPDOWN DE SELECCIÓN ÚNICA ========== */
.filter-dropdown {
    display: inline-block;
}

.filter-dropdown .filter-dropdown-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: transparent !important;
    color: #6c757d !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.filter-dropdown .filter-dropdown-btn:hover:not(:disabled) {
    background-color: #6c757d !important;
    color: white !important;
}

.filter-dropdown .filter-dropdown-btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5) !important;
}

.filter-dropdown .filter-dropdown-btn::after {
    margin-left: 8px;
}

.filter-dropdown .dropdown-item.active {
    background-color: #1f4f83 !important;
    color: white !important;
}

.filter-dropdown .dropdown-item:hover:not(.active) {
    background-color: #e9ecef !important;
}

/* ========== BOTÓN GENERAR ========== */
.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover:not(:disabled) {
    background-color: #5a6268 !important;
    border-color: #545b62 !important;
}

.niif-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== TOOLBAR ========== */
.niif-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

.niif-toolbar-right .table-toolbar-export-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #1f4f83 !important;
    color: white !important;
    border: 1px solid #1f4f83 !important;
}

.niif-toolbar-right .table-toolbar-export-btn:hover:not(:disabled) {
    background-color: #1a446f !important;
    border-color: #1a446f !important;
}

.niif-toolbar-right .table-toolbar-export-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== MODALES ========== */
.modal-header-custom {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    padding: 12px 20px;
}

.modal-footer-custom {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    padding: 12px 20px;
}

/* ========== ESTILOS DEL MODAL DE EMPRESAS ========== */
.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.custom-scroll-table {
    height: 250px;
    min-height: 250px;
    max-height: 300px;
    overflow-y: auto;
    position: relative;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== ESTILOS DE FLECHA Y TÍTULO ========== */
.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

/* ========== SWITCH TOGGLE ========== */
.compact-toggle-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.compact-switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    flex-shrink: 0;
}

.compact-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.compact-switch .compact-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .3s;
    border-radius: 24px;
}

.compact-switch .compact-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .3s;
    border-radius: 50%;
}

.compact-switch input:checked + .compact-slider {
    background-color: #1f4f83;
}

.compact-switch input:checked + .compact-slider:before {
    transform: translateX(20px);
}

/* ========== RESPONSIVE ========== */
@media (max-width: 1200px) {
    .niif-header .filter-select {
        min-width: 160px;
        max-width: 220px;
        height: 36px;
        font-size: 13px;
    }

    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 992px) {
    .niif-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        margin-left: 0 !important;
        justify-content: flex-start;
        gap: 6px;
    }

    .niif-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }

    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 768px) {
    .niif-toolbar-right {
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .compact-toggle-container {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }

    .niif-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }

    .niif-header .filters-container {
        gap: 4px;
    }

    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
        font-size: 13px;
        padding: 0 16px;
    }
}

.modern-spinner {
  position: relative;
  width: 60px;
  height: 60px;
  margin: 0 auto;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 4px solid transparent;
  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.spinner-ring:nth-child(1) {
  border-top-color: #1f4f83;
  animation-delay: -0.45s;
}

.spinner-ring:nth-child(2) {
  border-right-color: #4a90d9;
  animation-delay: -0.3s;
}

.spinner-ring:nth-child(3) {
  border-bottom-color: #7fb3e6;
  animation-delay: -0.15s;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-message {
  font-size: 15px;
  font-weight: 500;
  color: #243447;
  min-height: 24px;
  transition: opacity 0.3s ease;
}

.loading-submessage {
  font-size: 13px;
  color: #6c757d;
  min-height: 20px;
  margin-bottom: 8px;
}

.loading-progress-container {
  width: 100%;
  max-width: 320px;
  height: 4px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin: 8px auto 0;
}

.loading-progress-bar {
  height: 100%;
  width: 0%;
  background: linear-gradient(90deg, #1f4f83, #4a90d9, #7fb3e6);
  border-radius: 4px;
  transition: width 0.5s ease;
}

.loading-percentage {
  display: inline-block;
  margin-top: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #6c757d;
  min-width: 40px;
}


/* ========== FORZAR ALINEACIÓN A LA DERECHA EN CELDAS DE SALDOS ========== */
.admin-table-block :deep(table thead th.text-center) {
    text-align: center !important;
}

.admin-table-block :deep(table tbody td.text-right),
.admin-table-block :deep(table tbody td.text-right > *) {
    text-align: right !important;
    justify-content: flex-end;
}

</style>